import { useEffect } from "react";

import ChatWindow from '../../molecules/chatWindow'
import UserListWindow from '../../molecules/chatUsers'

import { useMemberState } from '../../contexts/membercontext'
import { useLoadMemberships, useLoadRequests } from "../../hooks/memberhooks";
import { MembershipSchema } from "../../data/types";

const Messages = () => {
  var { currentChatMember, 
    // loadMessages 
  } = useMemberState()
  // const loadCommunityMessages = async () => {
  //   if(loadMessages !== undefined){loadMessages()}
  // }

  var { memberships } = useLoadMemberships();
  const { membershipRequests } = useLoadRequests()
  if (membershipRequests){
    memberships = memberships ? [...memberships, ...membershipRequests] : membershipRequests
  }

  const currentMembership = memberships?.find((m: MembershipSchema) => m.uid === currentChatMember)
  
  useEffect(() => {
    document.title = `HomeCook | Messages ${(currentChatMember && currentChatMember === 'chatbot') ? `(${currentChatMember?.replace(/\w/, c => c?.toUpperCase())})` : (currentChatMember ? `(${currentChatMember})` : '')}`
    // loadCommunityMessages()
    // eslint-disable-next-line
  }, [currentChatMember])

      return (
         <div className="page-canvas mx-auto flex h-screen overflow-y-scroll">
            <div className="flex flex-col sm:flex-row w-full justify-start items-start">
                {/* <div className="w-auto sm:w-[400px]  bg-[#fff] rounded-md"> */}
                <div className={`${currentChatMember ? 'hidden sm:block': 'block'} w-4/12 bg-[#fff] rounded-none`}>
                    <UserListWindow memberships={memberships} />
                </div>

                {/* <div className="hidden sm:flex m-2 w-auto  bg-[#fff] rounded-md"> */}
                <div className={`${currentChatMember ? 'flex flex-col': 'hidden sm:block'} mx-1 w-8/12  bg-[#fff] rounded-none `}>
                    <ChatWindow currentMembership={currentMembership as MembershipSchema} />
                </div>
            </div>
             

        </div>
      )
}







export default Messages
